export enum ETemplateStudioProductPrioritiesFilter {
  ALL_SUB = 'all sub',
  ALL_MAIN = 'all main',
  MAIN_AND_SUBS = 'main & subs',
  WEB_ONLY = 'web only'
}

export enum ETemplateStudioBundlesViewModel {
  LINEAR = 'linear',
  TWO_IN_ONE = 'twoInOne',
  THREE_IN_ONE = 'threeInOne',
  SIX_IN_ONE = 'sixInOne',
  TWO_IN_ONE_DYNAMIC = 'twoInOneDynamic'
}

export enum ETemplateStudioFormBlocks {
  HEADER = 'Header',
  POPUP = 'Popup',
  BANNER = 'Banner',
  PROMOTION = 'Promotion',
  BUNDLE = 'Bundle',
  ROLLING_OFFER = 'Rolling Offer',
  RICH_TEXT = 'Rich Text',
  DAILY_BONUS_BADGE = 'Daily Bonus Badge',
  PLAYER_LEVEL = 'Player Level',
  FOOTER = 'Footer'
}

export enum ETemplateStudioLayoutOptions {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export enum EThemes {
  ROYAL_BLAST = 'royal-blast',
  HUUUGE = 'huuuge',
  PM_Franchise = 'product-madness-franchise',
  CASHMAN_CASINO = 'cashman-casino',
  EVERGREEN = 'evergreen',
  LIGHTNING_LINK_CASINO = 'lightning-link-casino',
  HEART_OF_VEGAS = 'heart-of-vegas',
  MIGHTY_FU_CASINO = 'mighty-fu-casino',
  CANDIVORE = 'candivore',
  BABA = 'baba',
  BAGELCODE = 'bagelcode',
  COMMUNIX = 'communix',
  BINGO_POP = 'bingo-pop',
  LOCO_BINGO = 'locobingo',
  GHOST = 'ghost',
  JUNES_JOURNEY = 'junes-journey',
  DECA = 'deca',
  PIPA = 'pipa',
  PLAYDOG = 'playdog',
  SPIN_X = 'spin-x',
  CASH_FRENZY = 'cash-frenzy',
  BANDITOS = 'banditos',
  DRIMAGE = 'drimage',
  FABEL_TOWN = 'fabel-town',
  LOAD_COMPLETE = 'load-complete',
  GENNMU = 'gennmu',
  ROYAL_MATCH = 'royal-match',
  KING = 'king'
}
